import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import '../../css/base.css';
import scenery5_large from '../../img/scenery5_large.jpg';

const PaymentSuccess = () => {

  const appstate = useSelector((state) => state.appState);

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  const { bookingDetails } = appstate;

  return (
    <div className="row">
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="keyText">
              <h4 className="availabilityCalendarTextBox">Payment Success</h4>
            </div>            
          </div>
        </div>
        <div className="row" style={{"margin-top": "1rem"}}>
        <div className="col-12 col-md-8">
          <div className="generalText">
            <div className="generalTextBox">
              Your booking at Shore Cottage as been confirmed.
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{"margin-top": "0"}}>
        <div className="col-12 col-md-8">
          <div className="generalText">
            <div className="generalTextBox">
              An email confirmation has been sent{bookingDetails && bookingDetails.contactDetails ? " to " + bookingDetails.contactDetails.email  : null}.
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{"margin-top": "0", "margin-bottom": "1rem"}}>
        <div className="col-12 col-md-8">
          <div className="generalText">
            <div className="generalTextBox">
              Any questions then please contact us.
            </div>
          </div>
        </div>
      </div>
        
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <img src={scenery5_large} alt="Welcome Door" className="gallery-image" />
      </div>
    </div>

  );
}

export default PaymentSuccess